/**
 * @generated SignedSource<<211c1184f3b15770e895026de202ab27>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MemberSelectAllMembersAutoCompleteRefetchQuery$variables = {
  count?: number | null | undefined;
  search?: string | null | undefined;
};
export type MemberSelectAllMembersAutoCompleteRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"MemberSelectAllEntitiesAutoCompleteFragment">;
};
export type MemberSelectAllMembersAutoCompleteRefetchQuery = {
  response: MemberSelectAllMembersAutoCompleteRefetchQuery$data;
  variables: MemberSelectAllMembersAutoCompleteRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": 10,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "search"
  }
],
v1 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MemberSelectAllMembersAutoCompleteRefetchQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          (v1/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "MemberSelectAllEntitiesAutoCompleteFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MemberSelectAllMembersAutoCompleteRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
          },
          (v1/*: any*/)
        ],
        "concreteType": "EntityConnection",
        "kind": "LinkedField",
        "name": "entities",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EntityEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isEntity"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "username",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayName",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "25832bf65694d2bfc08a059e6a23eb25",
    "id": null,
    "metadata": {},
    "name": "MemberSelectAllMembersAutoCompleteRefetchQuery",
    "operationKind": "query",
    "text": "query MemberSelectAllMembersAutoCompleteRefetchQuery(\n  $count: Int = 10\n  $search: String\n) {\n  ...MemberSelectAllEntitiesAutoCompleteFragment_3DeKgW\n}\n\nfragment MemberSelectAllEntitiesAutoCompleteFragment_3DeKgW on Query {\n  entities(first: $count, search: $search) {\n    ...MemberSelectAllEntitiesFragment\n  }\n}\n\nfragment MemberSelectAllEntitiesFragment on EntityConnection {\n  edges {\n    node {\n      __typename\n      id\n      ...MemberSelectEntityFragment\n    }\n  }\n}\n\nfragment MemberSelectEntityFragment on Entity {\n  __isEntity: __typename\n  id\n  username\n  displayName\n}\n"
  }
};
})();

(node as any).hash = "e286faa07e7f15c3d411cb5d800483c5";

export default node;
